export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";